module.exports = __webpack_public_path__ + "packs/media/images/brand_black-e0584b8eca1b170ce77d9c8ad938b12a.png";